export const CHAT_WELCOME_TITLE = 'Welcome to Aegiss';

export const CHAT_WELCOME_DESCRIPTION =
  'Ask questions about Singapore tax compliance and get answers grounded in official guidance and legislation.';

export const CHAT_EMPTY_STATE_HINT =
  'Conversation will appear here. Send a message to start.';

/** Shown while the assistant reply is streaming but no status/text has arrived yet. */
export const CHAT_THINKING_MESSAGE =
  'Working on your question — searching the tax guidance…';

export const EXAMPLE_CHAT_PROMPTS = [
  'What are the withholding tax rates in Singapore?',
  'What are the GST registration requirements in Singapore?',
  'When is corporate income tax paid in Singapore?',
  'Who needs to file income tax returns and when?',
] as const;
